import type { FC } from 'react';
import { cloneElement } from 'react';

import { useToggleContext } from '../toggle';
import type { IOn } from '../../models';

export const On: FC<React.PropsWithChildren<IOn>> = ({ children }) => {
    const { on, toggle } = useToggleContext();

    return on ? cloneElement(children, { onClose: toggle }) : null;
};
